import { useState } from "react";
import { useAlerts } from "@/hooks";
import { getErrorMessage } from "@/utils/getErrorMessage";
import { ISelectOption } from "@pulse-ui/types/components/DropdownInput";
import { useStartDefaultConfigMutation } from "../services/alertManagerApi";

export const useDefaultConfigModal = () => {
  const { showSuccess, showError } = useAlerts();
  const [open, setOpen] = useState(false);
  const [startDefaultConfig] = useStartDefaultConfigMutation();

  const handleStartDefaultConfig = async (selected: ISelectOption) => {
    try {
      await startDefaultConfig({ account_id: selected.value }).unwrap();
      showSuccess(`Default config started for ${selected.label}`);
      setOpen(false);
    } catch (err) {
      showError(`Failed to start default config: ${getErrorMessage(err)}`);
    }
  };

  return {
    open,
    openModal: () => setOpen(true),
    closeModal: () => setOpen(false),
    handleStartDefaultConfig,
  };
};
